import { COVERGO_ME_PROD } from "../consts.js"
import appConfigCoverGoMEProd from "./appConfigCovergoMEProd.js"

export const medgulf = {
	"medgulf-studio.dev.me.covergo.com": {
		appConfig: {
			tenantId: "medgulf_dev",
			appId: "admin_portal",
		},
		envConfig: {
			// TBD
		},
	},
	"medgulf-studio.uat.me.covergo.com": {
		appConfig: {
			tenantId: "medgulf_uat",
			appId: "admin_portal",
		},
		envConfig: {
			// TBD
		},
	},
	// Medgulf ME PROD
	"medgulf-studio.me.covergo.com": {
		appConfig: appConfigCoverGoMEProd,
		envConfig: COVERGO_ME_PROD,
	},
}
